import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';

import 'flickity-imagesloaded';
import ProductCard from '../components/product-card';

export default register('product-recently-viewed', {
  onLoad() {
    // Keep track of recently viewed products
    const limit = 4;
    const container = this.container;
    const productHandle = container.dataset.productHandle;
    const $slideContainer = container.querySelector('.recently-viewed__slider');
    const storage = localStorage.getItem('recentlyViewedProducts') || '[]';
    let recentProducts = JSON.parse(storage);
    const productIndex = recentProducts.indexOf(productHandle);
    const inArray = productIndex > -1;

    // Check if current item is in the array, and move it to the front
    if (inArray) {
      recentProducts.splice(productIndex, 1);
    }

    // Add current product to the start of the array
    if (productHandle) {
      recentProducts.unshift(productHandle);
    }

    // Cut the array down so we dont store a humungous amount of data
    recentProducts = recentProducts.splice(0, limit * 2);

    localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentProducts));

    // Start at 1 so we don't print the current product
    let index = 1;
    let markup = '';

    // Make the ajax request or prints out markup on completion
    async function getNextProduct() {
      // Have we hit the limit?
      if (recentProducts[index] && index <= limit) {
        const rootUrl = window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl;
        const url = `${rootUrl}/products/${recentProducts[index]}?view=recently-viewed`;

        try {
          const response = await fetch(url);
          if (response.ok) {
            const data = await response.text();
            markup += data;
          }
          index++;
          getNextProduct();
        } catch (err) {
          window.console.error(err);
        }
      } else {
        if (!markup) return;

        if ($slideContainer) {
          $slideContainer.innerHTML = markup;
          container.classList.remove('hide');
          const productCards = $slideContainer.querySelectorAll('.product-card');
          productCards.forEach((product) => {
            ProductCard(product);
          });

          // eslint-disable-next-line no-unused-vars
          const slider = new Flickity($slideContainer, {
            // options
            freeScroll: false,
            prevNextButtons: true,
            pageDots: true,
            imagesLoaded: true,
            setGallerySize: true,
            cellAlign: 'left',
            watchCSS: true,
            groupCells: true,
            arrowShape:
              'm12.075 51.432 27.04 23.66L36.572 78 4 49.5 36.571 21l2.545 2.908-27.04 23.66H95.8v3.864H12.075Z',
          });
        }
      }
    }

    // Check we got some products to show
    if (recentProducts.length > index) {
      getNextProduct();
    } else {
      container.classList.add('hide');
    }
  },
});
